// extracted by mini-css-extract-plugin
export default {"list":"imageList_list__4szol"};